import { render, staticRenderFns } from "./SystemUsers.vue?vue&type=template&id=bf2e3c28&"
import script from "./SystemUsers.vue?vue&type=script&lang=ts&"
export * from "./SystemUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports